import { useInfiniteContext } from '..'
import { InfiniteWaypoint } from './InfiniteWaypoint'

export function InfiniteContextWaypoint() {
  const infinite = useInfiniteContext()
  if (!infinite) return null
  return <InfiniteWaypoint infinite={infinite} />
}
